export const comments_5689025 = {"data":{"data":[],"links":{}}}